import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './totaltimetorepair.component.html',
    standalone: false
})
export class TotalTimeToRepairPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public totalTimeToRepairs: any;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.totalTimeToRepairs = this.plugin.config.TotalTimeToRepairs;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspection && this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection ? this.inspection.id : '',
      'plugins',
      this.plugin ? this.plugin.id : '',
      'totaltimetorepair',
      'edit'
    ];
  }
}

PluginComponent.plugins['totaltimetorepair'] = TotalTimeToRepairPluginComponent;
